import { render } from "./QuizPublicView.vue?vue&type=template&id=16a2440e&scoped=true&ts=true"
import script from "./QuizPublicView.vue?vue&type=script&lang=ts"
export * from "./QuizPublicView.vue?vue&type=script&lang=ts"

import "./QuizPublicView.vue?vue&type=style&index=0&id=16a2440e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16a2440e"]])

export default __exports__